import type { Language } from '@/domainLogic/index.ts';
import type { MapRef } from 'react-map-gl/mapbox';

export const MAP_DOT_INDEX = 21;

const setClickedMarkerWidth = (clickedMarkerWidth: number) => {
  window?.document?.documentElement?.style?.setProperty('--map-clicked-marker-width', `${clickedMarkerWidth}px`);
};

const adjustOverlayCardPosition = (marker: Element) => {
  const clickedMarkerWidth = marker?.clientWidth ? marker.clientWidth / 2 : 0;
  setClickedMarkerWidth(clickedMarkerWidth);
};

const removeMarkerSelection = (marker: Element) => {
  marker?.classList?.remove('openx-ui-marker-selected');
};

export const handleMarkerSelections = (actualId?: number) => {
  window?.document?.querySelectorAll('.openx-ui-marker-selected').forEach((marker) => {
    const dataId = marker?.getAttribute('data-id');
    const isClickedMarker = `${dataId}` === `${actualId}`;

    if (isClickedMarker) {
      adjustOverlayCardPosition(marker);
    } else {
      removeMarkerSelection(marker);
    }
  });
};

export const markerSelection = (selector?: string | number, selected?: boolean) => {
  if (!selector) return;
  const marker = document.querySelectorAll(`[data-id="${selector}"]`)[0];
  if (marker) {
    if (selected) {
      (marker as HTMLDivElement).classList.add('openx-ui-marker-selected');
    } else {
      (marker as HTMLDivElement).classList.remove('openx-ui-marker-selected');
    }
  }
};

export const airportMarkerSelection = (selector: string | number, selected: boolean) => {
  const marker = document.querySelectorAll(`[data-id="${selector}"]`)[0];
  if (marker) {
    if (selected) {
      (marker as HTMLDivElement).classList.add('openx-ui-airport-marker-selected');
    } else {
      (marker as HTMLDivElement).classList.remove('openx-ui-airport-marker-selected');
    }
  }
};

export const toggleMarkerSelectedBodyClass = () => {
  const body = document.querySelector('body');
  const selector = 'openx-ui-marker-popup-shown';
  body?.classList.remove(selector);
};

export const changeMapLanguage = (lang: Language, mapRef: React.RefObject<MapRef | null>) => {
  const map = mapRef?.current?.getMap();
  if (map) {
    const layers = mapRef?.current?.getStyle()?.layers;

    if (layers) {
      layers
        .filter((y) => y.id.indexOf('label') !== -1)
        .forEach((x) => {
          try {
            map.setLayoutProperty(x.id, 'text-field', [
              'coalesce',
              ['get', `name_${lang.toLowerCase()}`],
              ['get', 'name'],
            ]);
          } catch (error) {
            console.log(error);
          }
        });
    }
  }
};
